var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 9.931c0-.685-.56-1.241-1.25-1.241s-1.25.556-1.25 1.241v10.345c0 .685.56 1.241 1.25 1.241s1.25-.556 1.25-1.241V9.93zm-5 0c0-.685-.56-1.241-1.25-1.241s-1.25.556-1.25 1.241v10.345c0 .685.56 1.241 1.25 1.241s1.25-.556 1.25-1.241V9.93zm-5 0c0-.685-.56-1.241-1.25-1.241s-1.25.556-1.25 1.241v10.345c0 .685.56 1.241 1.25 1.241s1.25-.556 1.25-1.241V9.93zm12.5-2.483V22.76c0 .685-.56 1.24-1.25 1.24h-15c-.69 0-1.25-.555-1.25-1.24V6.207h17.5v1.241zM0 3.724c0-.685.56-1.241 1.25-1.241H7.5V1.24C7.5.556 8.06 0 8.75 0h2.5c.69 0 1.25.556 1.25 1.241v1.242h6.25c.69 0 1.25.556 1.25 1.241v1.241H0v-1.24z",
    fill: "#BDBDBD",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.844c35ba.svg";
export { ForwardRef as ReactComponent };